<template>
  <div class="page-follow-up-history">
    <div class="scroll-box">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="list.length >= 5 ? '没有更多了' : ''" @load="onLoad">
          <div class="card" v-for="item in list" :key="item.planCode" @click="openDetail(item)">
            <div class="top flex space-between align-center waiting">
              <span>{{ item.patientName }}的{{ item.planName }}</span>
              <van-tag
                v-if="!!patientPlanStatus[item.patientPlanStatus]"
                :color="patientPlanStatus[item.patientPlanStatus].color"
                :text-color="patientPlanStatus[item.patientPlanStatus].textColor"
                round
                size="large"
              >
                {{ patientPlanStatus[item.patientPlanStatus].text }}
              </van-tag>
            </div>
            <span class="doctor">{{ item.doctorName }} {{ item.doctorTitle }}</span>
            <div class="bottom flex space-between align-center">
              <template v-if="item.patientPlanStatus === 'WAIT_ACCEPT' || item.patientPlanStatus === 'EXPIRED'">
                <span class="date">截止加入日期：{{ item.planExpireTime }}</span>
                <span class="status" v-if="item.patientPlanStatus === 'WAIT_ACCEPT'">邀请{{ item.acceptExpireDays }}天后过期</span>
              </template>
              <div v-if="item.patientPlanStatus === 'EXECUTING' || item.patientPlanStatus === 'FINISHED'">
                <p class="date" style="margin-bottom: 4px;" v-if="item.patientPlanStatus === 'EXECUTING'"
                  >接受日期：{{ item.patientAcceptTime }}</p
                >

                <p class="date" v-if="item.patientPlanStatus === 'EXECUTING' || item.patientPlanStatus === 'FINISHED'">随访周期：{{ item.planCycleStartTime }}~{{ item.planCycleEndTime }}</p>
              </div>
              <span v-if="item.patientPlanStatus === 'EXECUTING' || item.patientPlanStatus === 'FINISHED'"
                >已完成{{ item.followUpDayFinishedCount }}/{{ item.followUpDayTotalCount }}次</span
              >
            </div>
          </div>
        </van-list>
        <Placeholder v-if="!loading && (!list || list.length === 0)" placeholderText="暂无历史健康计划" />
      </van-pull-refresh>
    </div>
    <!-- <div class="bottom-area">
      <van-button @click="viewHistory" block plain type="primary" :border="false" size="large">查看历史健康计划</van-button>
    </div> -->
  </div>
</template>
<script>
import Vue from 'vue';
import Placeholder from '@/components/Placeholder.vue';
import { patientPlanStatus } from './constant';
import { Tag } from '@zyf2e/capui-mobile';
Vue.use(Tag);

export default {
  components: {
    Placeholder
  },
  data() {
    return {
      patientPlanStatus: patientPlanStatus,
      list: [],
      params: {
        pageNo: 1,
        pageSize: 20,
        planStatus: 1, //计划状态（已结束1 未结束0）
      },
      loading: false,
      finished: false,
      refreshing: false,
    };
  },

  methods: {
    async fetchData() {
      return this.$fetch.fetchPostApiPatientHealthHealthPlanList(this.params);
    },
    async onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }

      try {
        this.loading = true;
        const { list } = await this.fetchData();
        this.list = [...this.list, ...list];
        this.params.pageNo++;
        this.loading = false;

        if (list.length < this.params.pageSize) {
          this.finished = true;
        }
      } catch (error) {
        this.loading = false;
        this.finished = true;
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      this.params = {
        pageNo: 1,
        pageSize: 20,
        planStatus: 1
      };

      this.onLoad();
    },
    openDetail(item) {
      this.$router.push({ path: `/follow-up/detail/${item.planCode}` });
    },
  },
};
</script>
<style lang="less" scoped>
.page-follow-up-history {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .scroll-box {
    flex: 1 1 auto;
    overflow: auto;
    margin-bottom: 10px;
  }
  .van-pull-refresh {
    min-height: 100%;
  }
  .bottom-area {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background: #fff;
  }
  /deep/ .van-tag {
    font-size: 12px;
    font-weight: 400;
  }

  .card {
    padding: 16px 16px 0;
    background: #fff;
    margin-top: 8px;
  }

  .waiting {
  }
  .action {
  }
  .done {
  }

  .top {
    height: 24px;
    font-size: 16px;
    font-weight: bold;
    color: #262626;
    line-height: 24px;

    // > * {
    //   white-space: nowrap;
    // }
    span {
      flex: 1 1 auto;
      max-width: 80%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .van-tag {
      flex: 0 0 auto;
    }
  }
  .doctor {
    display: block;
    // width: 103px;
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #8c8c8c;
    line-height: 14px;
    margin: 8px 0 10px;
  }
  .bottom {
    // height: 24px;
    padding: 6px 0 16px;
    background: #ffffff;
    font-size: 12px;
    font-weight: 400;
    color: #929292;
    line-height: 12px;
    // border-top: 0.5px solid #eeeeee;
    align-items: flex-end;

    .status {
      font-size: 12px;
      font-weight: 400;
      color: #ff373b;
      line-height: 12px;
    }
  }
}
</style>
